import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter as Router} from 'react-router-dom'

import {Provider} from 'react-redux'
import store from '../src/redux/store';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router >
      <Provider store = {store}>
        <App />
      </Provider>
    </Router>
  </React.StrictMode>
);

reportWebVitals();
